var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.TableTdCopy,
    { attrs: { value: _setup.value } },
    [
      !_vm.field.inline
        ? [
            _c("td", { staticStyle: { "min-width": "60px" } }, [
              _vm._v(" " + _vm._s(_setup.text) + " "),
            ]),
            _c("td", [_vm._v(" " + _vm._s(_setup.value) + " ")]),
          ]
        : _c(
            "td",
            { attrs: { colspan: "2" } },
            [
              _c(_setup.inputTextArea, {
                attrs: { readonly: "", rows: "10", label: _setup.text },
                model: {
                  value: _setup.value,
                  callback: function ($$v) {
                    _setup.value = $$v
                  },
                  expression: "value",
                },
              }),
            ],
            1
          ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }